module.exports = __webpack_public_path__ + "img/idcard2.93fe9d2e.png";